import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import GlobalDashboard from '../../pages/PracticeManagement/GlobalDashboard/GlobalDashboard';
import ProviderDashboard from '../../pages/ProviderDashboard/ProviderDashboard';
import CaregiverDashboard from '../../pages/CaregiverDashboard/CaregiverDashboard';
import SystemCaregiverDashboard from '../../pages/SystemCaregiverDashboard/SystemCaregiverDashboard';
import PracticeAdminHome from '../../pages/PracticeAdminDashboard/PracticeAdminHome';
import Layout from '../Layout/Layout/Layout';
import NonPatientRoute from '../Auth/NonPatientRoute/NonPatientRoute';

const DashboardSwitch = () => {
  const { user } = useSelector((state) => state.auth);
  const roleId = Number(user?.role_id);

  // Patients must use /patient-dashboard so Layout (sidebar) is always present.
  if (roleId === 6) {
    return <Navigate to="/patient-dashboard" replace />;
  }

  const getDashboardComponent = () => {
    switch (roleId) {
      case 1: // Super Admin
      case 2: // Admin
        return <GlobalDashboard />;
      case 3: // Practice Admin
        return <PracticeAdminHome />;
      case 4: // Provider
        return <ProviderDashboard />;
      case 5: // Practice Caregiver
        return <CaregiverDashboard />;
      case 7: // System Caregiver
        return <SystemCaregiverDashboard />;
      default:
        return <GlobalDashboard />;
    }
  };

  return (
    <NonPatientRoute>
      <Layout>
        {getDashboardComponent()}
      </Layout>
    </NonPatientRoute>
  );
};

export default DashboardSwitch;
